import axios from "axios"

const getCookie = (name: string) => {
    const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`));

    return cookie?.split('=')[1];
}

const PUBLIC_ENDPOINTS = [
    '/CreateTokenWin',
    '/GetHTMLContent'
    // Add more public endpoints as needed
];

const isPublicEndpoint = (url: string): boolean => {
    return PUBLIC_ENDPOINTS.some(endpoint => {
        // More precise matching - check if URL ends with the endpoint or has query params
        const cleanUrl = url.split('?')[0]; // Remove query parameters
        return cleanUrl === endpoint || cleanUrl.endsWith(endpoint);
    });
}

export const makeAPIRequest = async (data: any) => {
    axios.defaults.withCredentials = true;
    try {
        if (!isPublicEndpoint(data.url)) {
            const token = getCookie('accessToken');
            if (!token) {
                document.cookie.split(";").forEach(cookie => {
                    const eqPos = cookie.indexOf("=");
                    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
                    if (name.includes('accessToken') || name.includes('userName') || name.includes('role') || name.includes('dealerId') || name.includes('dealerCode')) {
                        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
                    }
                });
                window.location.href = '/';
                throw new Error('No access token found. Please log in.')
            }
        }
        const res = await axios.request(data);
        return res.data
    } catch (err: any) {
        if (err.response && err.response.status === 401) {
            // Clear cookies and redirect to login
            document.cookie.split(";").forEach(cookie => {
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
                if (name.includes('accessToken') || name.includes('userName') ||
                    name.includes('role') || name.includes('dealerId') || name.includes('dealerCode')) {
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
                }
            });
            window.location.href = '/';
        }
        throw err;
    }
}